/* eslint-disable max-len */
import { FunctionComponent } from 'react';
import defaultTheme from './DefaultTheme';

interface ApplyThemeProps {
  styleOverrides: any,
};

const ApplyTheme: FunctionComponent<ApplyThemeProps> = (props) => {
  const { styleOverrides } = props;

  const styles = {
    layout: { ...defaultTheme.layout, ...styleOverrides.layout },
    formControl: { ...defaultTheme.formControl, ...styleOverrides.formControl },
    formLabel: { ...defaultTheme.formLabel, ...styleOverrides.formLabel },
    errorMessage: { ...defaultTheme.errorMessage, ...styleOverrides.errorMessage }
  };

  let loadFont;
  if (styleOverrides?.loadGoogleFont) {
    loadFont = styleOverrides?.loadGoogleFont.trim().replace(/'|"/g, '').replace(' ', '+');
  }

  return (
    <>
      {loadFont &&
        <link rel="stylesheet" href={`https://fonts.googleapis.com/css2?family=${loadFont}&display=swap`} />
      }
      <style>
        {`
        * {
          box-sizing: border-box;
          font-size: 16px;
          font-family: inherit;
          margin: 0;
          padding: 0;
        }
        .card-number-form-control-wrapper {
          position: relative;
        }
        .card-number-icon-wrapper {
          display: flex;
          align-items: center;
          padding: ${styles.formControl.padding};
          position: absolute;
          bottom: 0;
          right: 0;
          top: 0;
        }
        .card-icon {
          font-size: 20px;
          height: 1em;
          margin-left: 2px;
          width: 1.666667em;
        }
        .form-label {
          color: ${styles.formLabel.color};
          display: inline-block;
          font-family: ${styles.formLabel.fontFamily};
          font-weight: ${styles.formLabel.fontWeight};
          font-size: ${styles.formLabel.fontSize};
          margin: ${styles.formLabel.margin};
        }
        .form-control {
          background-color: ${styles.formControl.backgroundColor};
          border-color: ${styles.formControl.borderColor};
          border-style: ${styles.formControl.borderStyle};
          border-bottom-width: ${styles.formControl.borderBottomWidth || styles.formControl.borderWidth};
          border-left-width: ${styles.formControl.borderLeftWidth || styles.formControl.borderWidth};
          border-right-width: ${styles.formControl.borderRightWidth || styles.formControl.borderWidth};
          border-top-width: ${styles.formControl.borderTopWidth || styles.formControl.borderWidth};
          border-radius: ${styles.formControl.borderRadius};
          box-shadow: ${styles.formControl.boxShadow || 'none'};
          color: ${styles.formControl.color};
          display: block;
          font-weight: ${styles.formControl.fontWeight};
          font-size: ${styles.formControl.fontSize};
          line-height: ${styles.formControl.lineHeight};
          margin: ${styles.formControl.margin};
          padding: ${styles.formControl.padding};
          outline: none;
          width: 100%;
        }
        .form-control:hover {
          border-color: ${styles.formControl.borderColorHover || styles.formControl.borderColor};
          background-color: ${styles.formControl.backgroundColorHover || styles.formControl.backgroundColor}
        }
        .form-control:focus {
          border-color: ${styles.formControl.borderColorFocus};
          box-shadow: ${styles.formControl.boxShadowFocus};
        }
        .form-control.error {
          border-color: ${styles.formControl.borderColorError};
          box-shadow: ${styles.formControl.boxShadowError};
        }
        .form-control.error:focus {
          box-shadow: ${styles.formControl.boxShadowErrorFocus};
        }
        .error-message {
          color: ${styles.errorMessage.color};
          margin: ${styles.errorMessage.margin};
          font-size: ${styles.errorMessage.fontSize};
          width: 100%;
        }
        .layout {
          font-family: ${styles.layout.fontFamily};
          display: flex;
          flex-direction: column;
          padding: ${styles.layout.padding};
          row-gap: ${styles.layout.formControlSpacingVertical};
        }
        .layout-row {
          display: flex;
          flex-direction: row;
          column-gap: ${styles.layout.formControlSpacingHorizontal};
          width: 100%;
        }
        .layout-column {
          flex-grow: 1;
        }
        
      /* Card Form Single Line
      =================== */

      .form-control-single-line-wrapper {
        padding: ${styles.formControl.padding};
        font-family: ${styles.layout.fontFamily};
      }

      .form-control-single-line {
        align-items: center;
        background-color: ${styles.formControl.backgroundColor};
        border-color: ${styles.formControl.borderColor};
        border-style: ${styles.formControl.borderStyle};
        border-bottom-width: ${styles.formControl.borderBottomWidth || styles.formControl.borderWidth};
        border-left-width: ${styles.formControl.borderLeftWidth || styles.formControl.borderWidth};
        border-right-width: ${styles.formControl.borderRightWidth || styles.formControl.borderWidth};
        border-top-width: ${styles.formControl.borderTopWidth || styles.formControl.borderWidth};
        border-radius: ${styles.formControl.borderRadius};
        box-shadow: ${styles.formControl.boxShadow || 'none'};
        display: flex;
        font-weight: ${styles.formControl.fontWeight};
        font-size: ${styles.formControl.fontSize};
        line-height: ${styles.formControl.lineHeight};
        margin: ${styles.formControl.margin};
        max-width: 100%;
        outline: none;
        padding: ${styles.formControl.padding};
      }
      .form-control-single-line:hover {
        border-color: ${styles.formControl.borderColorHover || styles.formControl.borderColor};
        background-color: ${styles.formControl.backgroundColorHover || styles.formControl.backgroundColor}
      }
      .form-control-single-line:focus, .form-control-single-line:focus-within {
        border-color: ${styles.formControl.borderColorFocus};
        box-shadow: ${styles.formControl.boxShadowFocus};
      }

      .form-control-single-line.error {
        border-color: ${styles.formControl.borderColorError};
        box-shadow: ${styles.formControl.boxShadowError};
      }

      .form-control-single-line.error:focus, .form-control-single-line.error:focus-within {
        border-color: ${styles.formControl.borderColorError};
        box-shadow: ${styles.formControl.boxShadowErrorFocus};
      }
      
      .form-control-single-line>*:not(:last-child) {
        margin-right: 4px;
      }
      
      .form-control-single-line-white>*:not(:last-child) {
        margin-right: 4px;
      }
      
      .form-control-single-line-input {
        width: 100%;
        border: none;
        background-color: transparent;
        color: ${styles.formControl.color};
        font-weight: ${styles.formControl.fontWeight};
        font-size: ${styles.formControl.fontSize};
        line-height: ${styles.formControl.lineHeight};
        outline: none;
      }
      
      /* Card Form Fields
      =================== */
      .form-control-single-line--number {
        flex-grow: 1;
      }
      
      .form-control-single-line--month>input {
        text-align: right;
      }
      
      .form-control-single-line--month,
      .form-control-single-line--year {
        width: 30px;
      }
      
      .form-control-single-line--cvv {
        width: 40px;
      }

      /* Screen Size and Logic Stylings
      =================== */

      @media screen and (max-width: 465px) {
        .number-input-single::placeholder {
            opacity: 0
        }
      }

      @media screen and (max-width: 360px) {
        .number-input-multi::placeholder {
            opacity: 0
        }
      }

      `}
      </style>
    </>
  );
};

export default ApplyTheme;
